<template>
	<div class="profile-settings">
		<h2 class="level-one-heading mb-5">Profilinställningar</h2>
		<hr>
		<div class="col-md-6">
			<div class="panel panel-primary">
				<div class="panel-heading">
					<h3 class="panel-title">{{ formSections.personal.label }}</h3>
				</div>
				<xform class="panel-body" :fields="formSections.name.fields" v-model="formData" />

				<div class="panel-link">
					<a-link :to="{name: 'info', params: { id: 25, name: 'Personuppgifter-och-integritetspolicy'}}">Kontakta oss för att ändra ditt namn</a-link>
				</div>

				<xform class="panel-body" :fields="formSections.personal.fields" :submitErrors="submitErrors" v-model="formData" @updateValidStatusArray="setInvalidArray" />
			</div>

			<div class="panel panel-primary">
				<div class="panel-heading">
					<h3 class="panel-title">{{ formSections.password.label }}</h3>
				</div>
				<xform class="panel-body" :fields="formSections.password.fields" :submitErrors="submitErrors" v-model="formData" @updateValidStatusArray="setInvalidArray" />
			</div>
		</div>

		<div class="col-md-6">
			<div class="panel panel-primary">
				<div class="panel-heading">
					<h3 class="panel-title">{{ formSections.member.label }}</h3>
				</div>
				<xform class="panel-body" :fields="formSections.member.fields" :submitErrors="submitErrors" v-model="formData" @updateValidStatusArray="setInvalidArray" />
				<div class="panel-body notification-settings">
					<p><b>Medlemsnummer: {{ user['id'] }}</b></p>
					<p>Om du behöver uppge ditt unika medlemsnummer i samband med någon av våra tävlingar etc</p>
				</div>
			</div>

			<div class="panel panel-primary">
				<div class="panel-heading">
					<h3 class="panel-title">{{ formSections.settings.label }}</h3>
				</div>
				<xform class="panel-body" :fields="formSections.settings.fields" v-model="formData" />
			</div>

			<div class="panel panel-primary">
				<div class="panel-heading">
					<h3 class="panel-title">Aviseringar om händelser på Webhallen.com</h3>
				</div>
				<div class="panel-body notification-settings">
					<label v-if="! userSettings.serious_business_mode" class="radio-checkbox-label">
						<input
							id="radioSetting1"
							v-model="formData.notificationSettingLevel"
							type="radio"
							name="inlineRadioOptions"
							:value="2"
						>
						<span
							class="checkbox-custom"
						>
							<span
								v-if="formData.notificationSettingLevel === 2"
								class="checkbox-dot"
							/>
						</span>
						<span class="radio-text">Beställningar och medlemsfunktioner</span>
					</label>

					<label class="radio-checkbox-label">
						<input
							id="radioSetting2"
							v-model="formData.notificationSettingLevel"
							type="radio"
							name="inlineRadioOptions"
							:value="1"
						>
						<span
							class="checkbox-custom"
						>
							<span
								v-if="formData.notificationSettingLevel === 1"
								class="checkbox-dot"
							/>
						</span>
						<span class="radio-text">Endast beställningar</span>
					</label>

					<label class="radio-checkbox-label">
						<input
							id="radioSetting3"
							v-model="formData.notificationSettingLevel"
							type="radio"
							name="inlineRadioOptions"
							:value="0"
						>
						<span
							class="checkbox-custom"
						>
							<span
								v-if="formData.notificationSettingLevel === 0"
								class="checkbox-dot"
							/>
						</span>
						<span class="radio-text">Inga</span>
					</label>
				</div>
			</div>
		</div>
		<div class="clearfix" />
		<center>
			<loading-spinner v-if="isSaving" />
			<text-button
				v-else
				class="mt-4"
				text="Spara ändringar"
				size="large"
				center
				width="wide"
				:disabled="invalidArray.length > 0"
				@click="submit"
			/>
		</center>
	</div>
</template>

<script>
import waja from 'waja';
import alert from 'alert';
import store from 'datastore';
import { error } from 'utils';
import { t } from 'datastore/i18n';
import { mapState } from 'vuex';

export default {
	store,
	props: ['user'],
	data () {
		return {
			formData: {},
			isSaving: false,
			invalidArray: [],
			submitErrors: false,
			formSections: {
				name: {
					label: 'Namn',
					fields:[
						{
							name: 'firstName',
							label: 'Förnamn',
							type: 'text',
							disabled: true,
						},
						{
							name: 'lastName',
							label: 'Efternamn',
							type: 'text',
							disabled: true,
						},
					],
				},
				personal: {
					label: 'Personuppgifter',
					fields: [
						{
							name: 'streetAddress',
							label: 'Adress',
							type: 'text',
						},
						{
							name: 'zipCode',
							label: 'Postnummer',
							type: 'number',
							pattern: '[0-9]*',
							inputmode: 'numeric',
						},
						{
							name: 'city',
							label: 'Postort',
							type: 'text',
						},
						{
							name: 'phoneNumber',
							label: 'Telefonnummer',
							type: 'tel',
							pattern: '[0-9]*',
							inputmode: 'tel',
						},
						{
							name: 'email',
							label: 'E-postadress',
							type: 'email',
							inputmode: 'email',
							required: true,
						},
						{
							name: 'emailRepeat',
							label: 'E-postadress (igen)',
							type: 'email',
							inputmode: 'email',
							emailComparison: '',
							required: true,
						},
					],
				},
				password: {
					label: 'Lösenord',
					fields: [
						{
							name: 'oldPassword',
							label: 'Gammalt lösenord',
							type: 'password',
						},
						{
							name: 'newPassword',
							label: 'Nytt lösenord',
							type: 'password',
						},
						{
							name: 'newPasswordRepeat',
							label: 'Nytt lösenord (igen)',
							type: 'password',
							passwordComparison: '',
						},
					],
				},
				member: {
					label: 'Medlemssystem',
					fields: [
						{
							name: 'seriousBusinessMode',
							label: 'Serious Business Mode',
							type: 'checkbox',
							description: 'Döljer medlemsfunktioner som Achievements, medlemsavatarer, Supply Drops m.m.',
						},
						{
							name: 'publicProfile',
							label: 'Publik profil',
							type: 'checkbox',
							helpText: 'Användarnamn och achievements blir synliga för andra medlemmar. Din orderhistorik eller annan personlig information delas däremot aldrig.',
						},
						{
							name: 'username',
							label: 'Användarnamn',
							type: 'text',
							required: true,
						},
					],
				},
				settings: {
					label: 'Inställningar',
					fields: [
						{
							name: 'shouldReceiveNewsletters',
							label: 'Prenumerera på Webhallens nyhetsbrev',
							type: 'checkbox',
						},
						{
							name: 'shouldReceiveSms',
							label: 'Ta emot SMS med information och erbjudanden',
							type: 'checkbox',
						},
						{
							name: 'showPricesExcludingVat',
							label: 'Visa priser exklusive moms',
							type: 'checkbox',
						},
					],
				},
			},
		};
	},
	computed: {
		...mapState({
			userSettings: state => state.user.settings,
		}),
	},
	methods: {
		tm: t.prefix('MEMBER'),
		submit () {
			if (this.invalidArray.length) {
				this.submitErrors = true;
			}

			if (this.formData.email !== this.formData.emailRepeat) {
				alert('E-postadresserna matchar inte!');
				return;
			}

			// @TODO detta är ett fulhack för att använda nya
			// inställningssystemet istället för kolumnen i användartabellen
			// i framtiden kanske vi vill flytta dit alla flaggor från user-tabellen
			// och uppdatera inställningarna i backend samt berätta för datastore att
			// de ändrats så att ändringarna syns direkt på sidan
			this.$store.dispatch('user/setSetting', {
				name: 'show_prices_excluding_vat',
				value: this.formData.showPricesExcludingVat,
			});

			this.isSaving = true;
			waja.post('profile-settings')
				.data(this.formData)
				.on('success', res => {
					this.isSaving = false;
					this.$store.dispatch('user/refresh');
					alert('Ändringarna har sparats!');
				})
				.on('400', res => {
					this.isSaving = false;
					res.text().then(data => {
						data = JSON.parse(data);
						if (data.error === 'field_mismatch') {
							alert('Lösenorden matchar inte!');
						} else if (data.error === 'short_password') {
							alert('Lösenorden måste vara minst 8 tecken lång');
						} else if (data.error === 'invalid_value') {
							if (data.field === 'username') {
								alert('Användarnamnet är inte giltigt! Namnet måste vara 4-50 tecken långt och får endast innehålla A-Ö, siffror, understreck och punkt.');
							} else if (data.field === 'oldPassword') {
								alert('Ditt gamla lösenord stämmer inte!');
							} else if (data.field === 'email') {
								alert('Mailadressen du försöker byta till är inte giltig!');
							} else {
								alert('Något av fälten är inte korrekt ifyllt!');
							}
						} else if (data.error === 'already_taken') {
							if (data.field === 'email') {
								alert('Det finns redan ett konto länkat till e-postadressen du angivit!');
							} else {
								alert('Det finns redan ett konto länkat till användarnamnet du angivit!');
							}
						}
					});
				})
				.catch(res => {
					this.isSaving = false;
					alert('Misslyckades med sparning!');
				})
				.go();
		},
		// Puts the names of all invalid input fields into an array
		setInvalidArray (to) {
			let newInvalidArray = this.invalidArray;

			Object.keys(to).forEach(function(key) {
				let keyExistsInArray = newInvalidArray.includes(key);

				if (keyExistsInArray && to[key] === true) {
					newInvalidArray.splice(newInvalidArray.indexOf(key), 1);
				} else if (! keyExistsInArray && to[key] === false) {
					newInvalidArray.push(key);
				}
			});

			this.invalidArray = newInvalidArray;
		},
	},
	beforeRouteEnter (to, frm, next) {
		waja.get('profile-settings')
			.on('success', res => {
				next(vm => {
					vm.formData = res.data.settings;
				});
			})
			.on('401', res => { // @TODO kolla vilken felkod det eg är
				next(error('404'));
			}).go();
	},
	watch: {
		formData (to) {
			let personalFields = this.formSections.personal.fields;
			let passwordFields = this.formSections.password.fields;

			for (let i = 0; i < personalFields.length; i++) {
				if (personalFields[i].name === 'emailRepeat') {
					personalFields[i].emailComparison = to.email;
				}
			}
			for (let i = 0; i < passwordFields.length; i++) {
				if (passwordFields[i].name === 'newPasswordRepeat') {
					passwordFields[i].passwordComparison = to.newPassword;
				}
			}
		},
	},
};
</script>
